import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { sortSizes } from '../utils';

function ProductFilters({ products, setSizeFilter, setItemsToShow }) {
  // Manage options for 'Filter by x' select menus in state
  const [productSizes, setProductSizes] = useState([]);

  useEffect(() => {
    // Function to find all the unique product sizes
    const uniqueProductSizes = [];
    products.forEach((product) => {
      // loop through all products
      for (let i = 0; i < product.options.length; i += 1) {
        // grab products 'Size'
        if (product.options[i].name === 'Size') {
          // from there, grab the values and loop
          for (let j = 0; j < product.options[i].values.length; j += 1) {
            // then push the values
            if (!uniqueProductSizes.includes(product.options[i].values[j])) {
              uniqueProductSizes.push(product.options[i].values[j]);
            }
          }
        }
        if (product.options[i].name === 'Talla') {
          // from there, grab the values and loop
          for (let j = 0; j < product.options[i].values.length; j += 1) {
            // then push the values
            if (!uniqueProductSizes.includes(product.options[i].values[j])) {
              uniqueProductSizes.push(product.options[i].values[j]);
            }
          }
        }
      }
    });

    const sortedSizes = sortSizes(uniqueProductSizes);

    // sortedSizes now contains an array of only the above possibilities.
    // Then we take the rest of the size options here...
    let tempSizes = uniqueProductSizes.filter(
      (size) => !sortedSizes.includes(size)
    );

    // ...and sort them alphabetically
    tempSizes = tempSizes.sort((a, b) => a.localeCompare(b));

    // Finally we append them to the original sorted array
    const sizeOptions = [].concat(sortedSizes, tempSizes);

    setProductSizes(sizeOptions);
  }, [products]);

  function handleProductFilter(e) {
    setItemsToShow(8);
    setSizeFilter(e.target.value);
  }

  return (
    <div className="flex w-full border-b border-light-pink">
      <div className="flex flex-wrap py-4">
        {productSizes.length > 1 && (
          <label htmlFor="filter_by_product_size">
            <span className="sr-only">Size</span>
            <select
              onChange={handleProductFilter}
              name="filter_by_product_size"
              id="filter_by_product_size"
              className="w-full uppercase rounded-none form-select border-light-pink"
            >
              <option key="All" value="All">
                All Sizes
              </option>
              {productSizes.map((productSize) => (
                <option key={productSize} value={productSize}>
                  {productSize}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
    </div>
  );
}

ProductFilters.propTypes = {
  products: PropTypes.array,
  setSizeFilter: PropTypes.func,
  setItemsToShow: PropTypes.func,
};

export { ProductFilters };
